import { Box, Flex } from '@chakra-ui/react';
import { components } from 'react-select';

import { Avatar } from 'uiToolkitV1/Avatar';
import { AvatarGroup } from 'uiToolkitV1/AvatarGroup';
import { Tooltip } from 'uiToolkitV1/Tooltip';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const TooltipLabelList = ({ labelList }) => (
  <Box>
    {labelList.map(({ id, label }) => (
      <TextBodyMedium key={id} color="#FFF">
        {label}
      </TextBodyMedium>
    ))}
  </Box>
);

export const MultiStepMenuSingleValue = (props) => {
  const { data } = props;
  if (data.selectedEmployees) {
    const noEmployees = data.selectedEmployees?.length === 0;
    const showName = data.selectedEmployees.length === 1;
    return (
      <components.SingleValue {...props}>
        <Tooltip label={noEmployees ? '' : <TooltipLabelList labelList={data.selectedEmployees} />}>
          <Box>
            {noEmployees ? (
              <TextBodyMedium>None</TextBodyMedium>
            ) : (
              <AvatarGroup>
                {data.selectedEmployees.map(({ id, label, profilePhoto }) => (
                  <Flex key={id} alignItems="center">
                    <Avatar w="22px" key={id} name={label} src={profilePhoto} mr="4px !important" />
                    {showName && (
                      <TextBodyMedium color="text.g1" mr="8px !important">
                        {label}
                      </TextBodyMedium>
                    )}
                  </Flex>
                ))}
              </AvatarGroup>
            )}
          </Box>
        </Tooltip>
      </components.SingleValue>
    );
  }

  return <components.SingleValue {...props} />;
};
